'use strict';

module.exports = function (ngModule) {
    ngModule.directive('numbersOnly', require('./numbersonly'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/numbersonly/index.js
 **/